import { render, staticRenderFns } from "./MenuBlock.vue?vue&type=template&id=2ca38fc8&scoped=true&"
import script from "./MenuBlock.vue?vue&type=script&lang=js&"
export * from "./MenuBlock.vue?vue&type=script&lang=js&"
import style0 from "./MenuBlock.vue?vue&type=style&index=0&id=2ca38fc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca38fc8",
  null
  
)

export default component.exports